import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { StudentListElementVM } from "@shared-kernel/application/ports/admin/admin-repository";

export const retrieveStudents = createAsyncThunk<StudentListElementVM[], void, { extra: Partial<Dependencies> }>(
  "students/retrieveStudents",
  async (_: void, { extra: { adminRepository } }) => {
    return adminRepository!.listStudents();
  },
);
